import { ICommunicationError } from "@dev/hc-talk-talk";
import IInitPasswordRenewalResponse from "@/app/dto/IInitPasswordRenewalResponse";
import InitPasswordRenewalRequest from "@/app/dto/InitPasswordRenewalRequest";
import ApiError from "@/app/model/ApiError";
import Api from "@/app/service/api";

class Alias {
    public verify(alias: string): Promise<IInitPasswordRenewalResponse> {
        return new Promise((resolve, reject) => {
            Api.initPasswordRenewal(new InitPasswordRenewalRequest(alias))
                .then((response: any) => {
                    resolve(response);
                })
                .catch((error: ICommunicationError) => {
                    reject(new ApiError(error));
                });
        });
    }
}

export default new Alias();
